<template>
    <b-form-group>
        <label for="" v-if="!!label">{{ label }} <span v-if="!!required" class="field-required-mark">*</span></label>
        <b-form-input type="number" v-bind="$attrs" v-on="$listeners"></b-form-input>
        <div class="field-error" v-if="!!hasError && !!errorMessage">{{ errorMessage }}</div>
    </b-form-group>
</template>
<script>
export default {
    inheritAttrs: false,
    props: {
        label: {
            type: String,
            default: ''
        },
        hasError: {
            type: Boolean,
            default: false
        },
        errorMessage: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        }
    }
}
</script>

